import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import QuestionTitle from './QuestionTitle';
import QuestionSubTitle from './QuestionSubTitle';
import QuestionOptionsContainer from './QuestionOptionsContainer';
// eslint-disable-next-line import/no-cycle
import QuestionRenderer from './QuestionRenderer';

const useStyles = makeStyles(() => ({
  compoundSimpleQuestionContainer: {
    marginBottom: '0 !important',
    '& > div': {
      marginBottom: 10,
    },
  },
}));

const noop = () => {};

export const SimpleMultipleCompoundQuestion = (props) => {
  const { question, onChange, value } = props;

  const classes = useStyles();

  const values = value ?? [{}];

  const setFieldValue = (valueObject) => onChange([
    {
      ...values[0],
      [valueObject.name]: valueObject.values,
    },
  ]);

  return (
    <Grid key={question?.id}>
      <QuestionTitle label={question?.title ?? ''} />

      {question?.subtitle && <QuestionSubTitle label={question.subtitle} />}

      <QuestionOptionsContainer>
        <Grid className={`${classes.compoundSimpleQuestionContainer}`}>
          {question.subQuestions.map((subQuestion) => (
            <QuestionRenderer
              question={subQuestion}
              value={values[0][subQuestion?.id]}
              onChange={setFieldValue}
              key={subQuestion?.id}
              handleNextButtonClick={noop}
            />
          ))}
        </Grid>
      </QuestionOptionsContainer>

    </Grid>
  );
};

SimpleMultipleCompoundQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array,
};
